// tool/layout-view
var Marionette = require('backbone.marionette');
var template = require('./layout-template.hbs');
var MapView = require('./maps/view');
var DetailsLayoutView = require('./details/layout-view');
var ControlsView = require('./controls/view');
var Collection = require('./collection');

var Radio = require('backbone.radio');
var routerChannel = Radio.channel('router');
var toolChannel = Radio.channel('tool');

module.exports = Marionette.LayoutView.extend({
	template: template,
	className: 'tool container',
  regions: {
    map: '.tool__map',
    details: '.tool__details',
		controls: '.tool__controls'
  },

	initialize: function() {
		this.startupData = new Collection();
		// add collection reference to MapState
		UCS.App.MapState.set('collection_copy', this.startupData);

		this.startupData.load();

		this.listenTo(toolChannel, 'startups:density:done', function(){

			var type = UCS.App.MapState.get('type');

			var densityGroup = {
				'state_assembly': this.startupData.state_assembly_districts_density,
				'state_senate': this.startupData.state_senate_districts_density,
				'congressional':	this.startupData.congressional_districts_density,
				'county': this.county_districts_density
			};

			this.showMap(this.startupData, densityGroup[type], this.options);
			this.showDetail(this.startupData);
			this.showControls(this.startupData);
		});


	},

	// onBeforeShow: function() {
	// },
	//

	onDestroy: function(){
		// Empty out the collection on layoutview close http://backbonejs.org/#Collection-reset

		// unregister event listeners
		toolChannel.reset();
		routerChannel.off('map:update:boundary');
		// UCS.App.MapState.off('change:id');
		// UCS.App.MapState.off('change:selection');
		// UCS.App.MapState.off('change:type'); // commented out since it breaks MapState updating boundary path info
	},

	showMap: function(startupData, density, options){
		// default to State Assembly
		var shapedata_path = UCS.App.MapState.get('path');

		var map = new MapView({
			collection: startupData,
			campus_data_path: "data/uc_campuses.csv",
			cities_data_path: "data/ca_largest_cities_2010.csv",
			shapedata_path: shapedata_path,
			base_height: 768,
			base_scale: 2900,
			density: density,
			id:"map_1_svg",
			// subview_id:":map_01",
			// division_type:"state_assembly",

			type: "map",
			orientation: "portrait",
			breakpoints: {
				"3440": 1.5,
				"2560": 1.4,
				"1920": 1.3,
				"1680": 1.2,
				"1440": 1,
				"1366": 1,
				"1280": 1,
				"1080": 1,
				"1024": 0.9,
				"768": 0.8,
				"600": 0.6,
				"420": 0.5,
				"320": 0.4
			},
      margin: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
		});
		this.showChildView('map', map);
	},

	showDetail: function(startupData){
		var detail = new DetailsLayoutView({
			collection: startupData
		});
		this.showChildView('details', detail);
	},

	showControls: function(startupData){
		var controls = new ControlsView({
			collection: startupData
		});
		this.showChildView('controls', controls);
	},


});
